import { parseDomain } from '../../utils';
import { dynamicLoadApiQueries } from './dynamicLoadApiQueries';
export const canPurchaseOrConnect = async _ref => {
  let {
    httpClient,
    request: {
      domain,
      msid
    }
  } = _ref;
  if (!domain) {
    return {
      canPurchase: false,
      canConnect: false
    };
  }
  const parsedDomain = domain.main ? domain : parseDomain(domain);
  const {
    canPurchaseDomain,
    canConnectOrBindDomain
  } = await dynamicLoadApiQueries(httpClient);
  const [canPurchase, canConnect] = await Promise.all([canPurchaseDomain({
    domain: parsedDomain.asciiDomain
  }), canConnectOrBindDomain({
    domain: parsedDomain.asciiDomain,
    msid: msid ?? ''
  })]);
  return {
    canPurchase: canPurchase.canPurchase,
    canConnect: canConnect.canConnectOrBind,
    purchaseError: canPurchase.error,
    connectError: canConnect.error
  };
};
//# sourceMappingURL=canPurchaseOrConnect.js.map